const getBaseUrl = (): string => {
  if (import.meta.env.DEV) {
    return ''; // En desarrollo las peticiones van a mismo origen y Vite hace proxy a la API
  }
  return import.meta.env.VITE_API_BASE_URL || 'https://dumas.solutions';
};

const getToken = (): string | null => {
  try {
    return localStorage.getItem('auth_token');
  } catch {
    return null;
  }
};

export async function apiFetch(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  const base = getBaseUrl().replace(/\/$/, '');
  const url = path.startsWith('http') ? path : `${base}${path.startsWith('/') ? path : `/${path}`}`;
  const token = getToken();
  const headers = new Headers(options.headers);
  headers.set('Content-Type', 'application/json');
  if (token) headers.set('Authorization', `Bearer ${token}`);
  return fetch(url, { ...options, headers });
}

function isNetworkError(e: unknown): boolean {
  const msg = e instanceof Error ? e.message : String(e);
  return (
    msg === 'Failed to fetch' ||
    msg === 'Load failed' ||
    msg === 'NetworkError when attempting to fetch resource.' ||
    (e instanceof TypeError && msg.includes('fetch'))
  );
}

export async function apiJson<T>(path: string, options?: RequestInit): Promise<T> {
  let res: Response;
  try {
    res = await apiFetch(path, options);
  } catch (e) {
    if (isNetworkError(e)) {
      throw new Error(
        'No se pudo conectar con el servidor. Comprueba la conexión y que la URL de la API sea correcta (CORS si estás en otro dominio).'
      );
    }
    throw e;
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error((data as { error?: string })?.error || res.statusText || 'Error');
    (err as Error & { status?: number }).status = res.status;
    throw err;
  }
  return data as T;
}
